import { EditStoreProps } from '@/main/store/@types/edit.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { DEPENDENT_TABLES as depTableNames, NAME as name, CRUMB_LABEL_KEY, PP, ND } from '../constants';
import { provider as apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	edit: {},
	depTableNames,
	depTableSettings: {
		[PP]: {
			filter(state) {
				return { CapaketId: state.props.id };
			},
		},
		[ND]: {
			filter(state) {
				return { CapaketId: state.props.id };
			},
		},
	},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	} as EditStoreProps,
});
